<template>
    <TransitionFade>
        <div v-show="props.popupBannersModalVisible" class="ppbnrs-modal">
            <div class="ppbnrs-modal__background" @click="emit('close-popup-banners-modal')"></div>
            <div class="ppbnrs-modal__content">
                <button
                    type="button"
                    class="ppbnrs-modal__close"
                    @click="emit('close-popup-banners-modal')"
                    aria-label="Zavřít"
                ></button>

                <h2 class="ppbnrs-modal__title">Zvyšte svou šanci na výhru&nbsp;✌️.</h2>
                <div class="ppbnrs-modal__banners">
                    <div class="ppbnrs-banner">
                        <WebpImage
                            src="/frontend/kasa-loyalty/img/homepage/sportka-banner-bg.jpg"
                            cssClass="ppbnrs-banner__bg"
                            alt="Sportka - obrázek na pozadí"
                        />

                        <WebpImage
                            src="/frontend/kasa-loyalty/img/tickets/sportka-dark.png"
                            cssClass="ppbnrs-banner__logo"
                            alt="Sportka - logo"
                        />
                        <h3 class="ppbnrs-banner__title">Hrajte o <br />{{ jackpotSportkaTitle }}</h3>
                        <a href="/loterie/sportka/sazky-a-vysledky" class="btn btn-secondary">
                            Více o loterii sportka
                        </a>
                    </div>
                    <div class="ppbnrs-banner">
                        <WebpImage
                            src="/frontend/kasa-loyalty/img/homepage/eurojackpot-banner-bg.jpg"
                            cssClass="ppbnrs-banner__bg"
                            alt="Sportka - obrázek na pozadí"
                        />
                        <WebpImage
                            src="/frontend/kasa-loyalty/img/tickets/eurojackpot.png"
                            cssClass="ppbnrs-banner__logo"
                            alt="Sportka - logo"
                        />
                        <h3 class="ppbnrs-banner__title">Hrajte o <br />{{ jackpotEurojackpotTitle }}</h3>
                        <a href="/loterie/eurojackpot/sazky-a-vysledky" class="btn btn-secondary">
                            Více o loterii eurojackpot
                        </a>
                    </div>
                </div>
                <div class="ppbnrs-modal__note">
                    Při každém svém nákupu loterie nebo losu použijte Sazka kartu. Následující den si zatočíte Kolem
                    štěstí a získáte svou extra šanci na výhru.
                </div>
            </div>
        </div>
    </TransitionFade>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";
import "@/../../css/widgets/popup-banners/popup-banners.scss";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { StringHelper } from "@/helpers/string-helper";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { useStackedModals } from "@sazka/utils/composables/use-stacked-modals";

const props = defineProps<{
    popupBannersModalVisible: boolean;
    jackpotSportka: number;
    jackpotEurojackpot: number;
}>();

const emit = defineEmits(["close-popup-banners-modal"]);

const jackpotSportkaTitle = computed(() => {
    return props.jackpotSportka > 0 ? `${StringHelper.toCurrencyString(props.jackpotSportka)}` : "milionové výhry";
});
const jackpotEurojackpotTitle = computed(() => {
    return props.jackpotEurojackpot > 0
        ? `${StringHelper.toCurrencyString(props.jackpotEurojackpot)}`
        : "miliardové výhry";
});

const { addToStackedModals, removeFromStackedModals } = useStackedModals();
watch(
    () => props.popupBannersModalVisible,
    (newOpened) => {
        if (newOpened) {
            addToStackedModals();
        } else {
            removeFromStackedModals();
        }
    }
);
</script>
